import { isAxiosError } from 'axios';

type ApiErrorPayload = {
  code?: unknown;
  message?: unknown;
};

function readErrorPayload(error: unknown): ApiErrorPayload | undefined {
  if (!isAxiosError(error)) return undefined;

  const { data } = error.response ?? {};
  if (!data || typeof data !== 'object') return undefined;

  return data as ApiErrorPayload;
}

export function getApiErrorMessage(error: unknown, fallbackMessage = 'Ocorreu um erro inesperado.'): string {
  const payload = readErrorPayload(error);
  const code = typeof payload?.code === 'string' ? payload.code.trim() : '';
  const message = typeof payload?.message === 'string' ? payload.message.trim() : '';

  if (message) return message;
  if (code) return code;

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallbackMessage;
}
